import { useAuth } from '@saltus/auth';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrevious from '../../services/usePrevious';
import isInGroup from '../../services/util/isInGroup';
import debug from '../../services/debug';

const MAINTENANCE_CHECK_TIME_INTERVAL = 30;

function AppMaintenance({
  session,
  handleGetSession,
  handleGetGlobalMaintenanceMode,
  maintenancemode,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const prevSession = usePrevious({ session });

  useEffect(() => {
    if (!prevSession) {
      handleGetSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useEffect(() => {
    const auth = !!user;

    let timerId;

    if (import.meta.env.PROD) {
      debug('AppMaintenanceUser', user);
      handleGetGlobalMaintenanceMode(auth);

      timerId = setInterval(() => {
        handleGetGlobalMaintenanceMode(auth);
      }, MAINTENANCE_CHECK_TIME_INTERVAL * 1000);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!session || _.isEmpty(session)) return <span />;
  if (!maintenancemode || _.isEmpty(maintenancemode)) return <span />;
  if (!isInGroup(session, 'Admin')) {
    if (maintenancemode.Mode !== 'online') {
      if (location.pathname !== '/maintenance') {
        navigate('/maintenance', {
          state: {
            maintenancemessage: maintenancemode.Message,
          },
        });
      }
    } else if (location.pathname === '/maintenance') {
      navigate('/');
    }
  }
  return null;
}

AppMaintenance.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  session: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  maintenancemode: PropTypes.object,
  handleGetSession: PropTypes.func,
  handleGetGlobalMaintenanceMode: PropTypes.func,
};

AppMaintenance.defaultProps = {
  session: {},
  maintenancemode: {},
  handleGetSession: () => {},
  handleGetGlobalMaintenanceMode: () => {},
};

export default AppMaintenance;
